<template>
    <h1 class="faq__content-title">
        {{ nodeData.attributes?.title }}
    </h1>
    <div class="faq__content-body" v-html="articleBody" />
</template>

<script>
export default {
    name: 'FAQArticle',
    props: {
        nodeData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        articleBody() {
            return this.nodeData.attributes?.body;
        }
    },
}
</script>